import { SiPython, SiC, SiPhp, SiGo } from 'react-icons/si'
import { DiJava } from 'react-icons/di'
// @ts-ignore
import React from 'react'

interface SkillsType {
  name: string
  icon: any
  link: string
}

export const BackEndSkillsData: SkillsType[] = [
  {
    name: 'Java',
    icon: <DiJava color="#ffffffdc" />,
    link: 'https://www.javascript.com/',
  },
  {
    name: 'Python',
    icon: <SiPython color="#ffffffdc" />,
    link: 'https://www.typescriptlang.org/',
  },
  {
    name: 'C',
    icon: <SiC color="#ffffffdc" />,
    link: 'https://reactjs.org/',
  },
  {
    name: 'PHP',
    icon: <SiPhp color="#ffffffdc" />,
    link: 'https://nextjs.org/',
  },
  {
    name: 'Go Lang',
    icon: <SiGo color="#ffffffdc" />,
    link: 'https://redux.js.org/',
  },
]
